import { InlineMentions } from "../mentions";
import PropTypes from "prop-types";
import React from "react";

export default function StandardMentions({ children, ...props }) {
  return (
    <InlineMentions {...props}>
      {({
        mentionQuery,
        acceptSuggestion,
        selectedSuggestionIndex,
        offeredSuggestions,
        offerSuggestions,
      }) =>
        children({
          query: mentionQuery,
          onChange: offerSuggestions,
          acceptSuggestion,
          suggestions: offeredSuggestions,
          selectedIndex: selectedSuggestionIndex,
        })
      }
    </InlineMentions>
  );
}

StandardMentions.propTypes = {
  children: PropTypes.func.isRequired,
};
